export const InspectData = [
  {
    check: false,
    title: "타워크레인을 설치·조립·해체하는 작업",
    typeLists: [
      {
        type: "note",
        title: "타워크레인을 설치·조립·해체하는 작업",
        data: [
          {
            content: "1. 설치/해체 순서, 방법을 근로자는 주지하고 있는가?",
            isChecked: "",
          },
          {
            content: "2. 상승작업 중 턴테이블 하부와 텔레스코핑케이지의 볼트, 핀 등은 견고히 체결되었는가?",
            isChecked: "",
          },
          {
            content: "3. 텔레스코핑 슈 등 유압장치는 정상적으로 작동하고 있는가?",
            isChecked: "",
          },
          {
            content: "4. 작업팀원 역할분담과 지휘명령계통이 명확한가?",
            isChecked: "",
          },
          {
            content: "5. 풍속 등 기상 상황은 확인하였는가?",
            isChecked: "",
          },
          {
            content: "6. 대차 레일, 부재 등은 손상·변형이 없는가?",
            isChecked: "",
          },
          {
            content: "7. 이동식크레인 정격하중, 위치 선정 등은 적정한가?",
            isChecked: "",
          },
          {
            content: "8. 줄걸이 용구(슬링 등)은 적정한가?",
            isChecked: "",
          },
          {
            content: "9. 상승작업 중 턴테이블 하부와 텔레스코핑 케이지의 볼트, 핀 등은 견고히 체결되었는가?",
            isChecked: "",
          },
        ],
      },
      {
        type: "",
        title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
        data: [
          {
            content: ["가", "타워크레인의 종류 및 형식"],
            isChecked: "",
          },
          {
            content: ["나", "설치·조립 및 해체순서"],
            isChecked: "",
          },
          {
            content: ["다", "작업도구·장비·가설설비(假設設備) 및 방호설비"],
            isChecked: "",
          },
          {
            content: ["라", "작업인원의 구성 및 작업근로자의 역할 범위"],
            isChecked: "",
          },
          {
            content: ["마", "제142조에 따른 지지 방법"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "차량계 하역운반기계 등을 사용하는 작업",
    typeLists: [
      {
        type: "note",
        title: "차량계 하역운반기계 등을 사용하는 작업",
        data: [
          {
            content: "1. 작업계획서를 작성하고 계획에 따라 작업하는가?",
            isChecked: "",
          },
          {
            content: "2. 작업지휘자를 지정하여 작업계획서에 따라 작업을 지휘하는가?",
            isChecked: "",
          },
          {
            content: "3. 청소차 적재함 등 승차석이 아닌 위치에 근로자가 탑승하지는 않는가?",
            isChecked: "",
          },
          {
            content: "4. 운전자는 제한속도를 준수하는가?",
            isChecked: "",
          },
          {
            content: "5. 운전자가 운전위치 이탈 시 시동키 분리 등 안전사항을 지키는가?",
            isChecked: "",
          },
          {
            content: "6. 하역·운반 중인 화물이나 차량계 하역운반기계에 접촉될 우려가 있는곳에 근로자의 출입을 금지하는가?",
            isChecked: "",
          },
          {
            content: "7. 차량계 하역운반기계에 화물 적재 운전자의 시야 확보 등 안전사항을 지키는가?",
            isChecked: "",
          },
          {
            content: "8. 차량계 하역운반기계를 화물자동차에 싣거나 내리는 작업을 할 때 전도·전락 위험을 방지하고 있는가?",
            isChecked: "",
          },
          {
            content: "9. 차량계 하역운반기계는 화물의 적재·하역 등 주된 용도에만 사용하는가?",
            isChecked: "",
          },
          {
            content: "10. 차량계 하역운반기계의 수리 또는 부속장치의 장착 및 해체작업 시 작업 지휘자를 지정하여 작업을 지휘하는가?",
            isChecked: "",
          },
          {
            content: "11. 차량에는 백밀러, 룸밀러 및 CCTV 등이 설치되었는가?",
            isChecked: "",
          },
          {
            content: "12. 운전자는 운전 시 안전벨트를 항상 착용하는가?",
            isChecked: "",
          },
          {
            content: "13. 차량은 정기적으로 검사를 받고 있는가?",
            isChecked: "",
          },
          {
            content: "14. 폐기물을 하역하는 동안 차량들은 차량 하나의 넓이만큼 서로 떨어져 있는가?",
            isChecked: "",
          },
          {
            content: "15. 모든 근로자들은 작업장 내에서 쉽게 눈에 띄는 작업복을 착용하는가?",
            isChecked: "",
          },
        ],
      },
      {
        title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
        data: [
          {
            content: ["가", "해당 작업에 따른 추락·낙하·전도·협착 및 붕괴 등의 위험 예방대책"],
            isChecked: "",
          },
          {
            content: ["나", "차량계 하역운반기계등의 운행경로 및 작업방법"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "차량계 건설기계를 사용하는 작업",
    typeLists: [
      {
        type: "note",
        title: "차량계 건설기계를 사용하는 작업",
        data: [
          {
            content: "1. 차량계 건설기계에 대한 작업계획을 수립하여 계획대로 시행하고 있는가?",
            isChecked: "",
          },
          {
            content: "2. 차량계 건설기계는 유자격자가 운전하고 있는가?",
            isChecked: "",
          },
          {
            content: "3. 폭풍, 폭우, 폭성 등의 악천후 시 작업을 중지하고 있는가?",
            isChecked: "",
          },
          {
            content: "4. 유도자를 배치하여 작업을 유도하고 있는가?",
            isChecked: "",
          },
          {
            content: "5. 일정한 방법을 정하여 신호하고 있는가?",
            isChecked: "",
          },
          {
            content: "6. 기계의 작업범위 내에 관계자외의 출입을 금지하고 있는가?",
            isChecked: "",
          },
          {
            content: "7. 작업전 운전자 및 근로자 안전교육을 실시하고 있는가?",
            isChecked: "",
          },
          {
            content: "8. 지정된 제한속도를 준수하고 있는가?",
            isChecked: "",
          },
          {
            content: "9. 승차석 이외의 위치에 근로자가 탑승하지 않고 있는가?",
            isChecked: "",
          },
          {
            content: "10. 운전석 이탈시 원동기 정지, 브레이크 작동 등 이탈방지조치를 하고, 버킷 등 작업장치를 지면에 내려놓고 있는가?",
            isChecked: "",
          },
          {
            content: "11. 사용전 안전장치 이상 유무를 확인하였는가?\n※ 안전장치 : 전조등, 경보장치, 헤드가드, 붐 전도방지 장치, 붐 권상드럼 역회전방지장치, 기타",
            isChecked: "",
          },
          {
            content: "12. 건설기계를 싣거나 내리는 작업은 평탄하고 견고한 장소에서 실시하는가?",
            isChecked: "",
          },
          {
            content: "13. 운반기계의 바퀴에 굄목 등을 확실하게 받치고 있는가?",
            isChecked: "",
          },
        ],
      },
      {
        title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
        headerTitle: "사전조사 내용",
        data: [
          {
            content: ["가", "해당 기계의 굴러 떨어짐, 지반의 붕괴 등으로 인한 근로자의 위험을 방지하기 위한 해당 작업장소의 지형 및 지반상태"],
            isChecked: "",
          },
        ],
      },
      {
        // title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
        noMargin: true,
        data: [
          {
            content: ["가", "사용하는 차량계 건설기계의 종류 및 성능"],
            isChecked: "",
          },
          {
            content: ["나", "차량계 건설기계의 운행경로"],
            isChecked: "",
          },
          {
            content: ["다", "차량계 건설기계에 의한 작업방법"],
            isChecked: "",
          },
        ],
      },
    ],
  },
  {
    check: false,
    title: "중량물의 취급 작업",
    typeLists: [
      {
        type: "note",
        title: "중량물의 취급 작업",
        data: [
          {
            content: "① 화물의 종류, 형상 등에 적합한 운반ㆍ취급방법 선정",
            isChecked: "",
            title: "1. 인력 및 이동대차 작업",
          },
          {
            content: "② 적재 화물의 종류별로 규정된 적재방법 준수",
            isChecked: "",
            title: "1. 인력 및 이동대차 작업",
          },
          {
            content: "③ 올바른 인력운반 취급요령 준수",
            isChecked: "",
            title: "1. 인력 및 이동대차 작업",
          },
          {
            content: "④ 임의 구름방지장치 부착 등 이동대차 안전장치 부착",
            isChecked: "",
            title: "1. 인력 및 이동대차 작업",
          },
          {
            content: "⑤ 인력 및 이동대차 운반 안전통행로 확보",
            isChecked: "",
            title: "1. 인력 및 이동대차 작업",
          },
          {
            content: "① 무자격자(기능, 경험) 에 의한 운전 금지",
            isChecked: "",
            title: "2. 지게차 작업",
          },
          {
            content: "② 헤드가드, 백레스트, 안전벨트 등 운전자 보호장치 부착",
            isChecked: "",
            title: "2. 지게차 작업",
          },
          {
            content: "③ 지게차와 보행자 운행통로 구획 관리",
            isChecked: "",
            title: "2. 지게차 작업",
          },
          {
            content: "④ 적재하중 및 제한속도 준수",
            isChecked: "",
            title: "2. 지게차 작업",
          },
          {
            content: "① 과부하 방지장치 등 크레인 각종 방호장치 정상 기능 유지",
            isChecked: "",
            title: "3. 크레인 작업",
          },
          {
            content: "② 운전자와 지정신호수 간 일정한 신호에 의한 화물 운반",
            isChecked: "",
            title: "3. 크레인 작업",
          },
          {
            content: "③ 안전모, 안전화 등 개인보호구 착용",
            isChecked: "",
            title: "3. 크레인 작업",
          },
          {
            content: "④ 크레인 작업반경 내 출입금지 및 급격한 조작금지",
            isChecked: "",
            title: "3. 크레인 작업",
          },
          {
            content: "① 출입문 연동장치 등 리프트/화물용 승강기 각종 방호장치 정상 기능 유지",
            isChecked: "",
            title: "4. 기타 운반기계 작업",
          },
          {
            content: "② 승강로 바닥 주변에 방호울 설치",
            isChecked: "",
            title: "4. 기타 운반기계 작업",
          },
          {
            content: "③ 화물 이탈 방지 등을 위한 컨베이어 방호장치 부착",
            isChecked: "",
            title: "4. 기타 운반기계 작업",
          },
          {
            content: "④ 수리ㆍ점검 중 전원 차단 및 ‘조작금지’ 표지판 부착",
            isChecked: "",
            title: "4. 기타 운반기계 작업",
          },
        ],
      },
      {
        title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
        data: [
          {
            content: ["가", "추락위험을 예방할 수 있는 안전대책"],
            isChecked: "",
          },
          {
            content: ["나", "낙하위험을 예방할 수 있는 안전대책"],
            isChecked: "",
          },
          {
            content: ["다", "전도위험을 예방할 수 있는 안전대책"],
            isChecked: "",
          },
          {
            content: ["라", "협착위험을 예방할 수 있는 안전대책"],
            isChecked: "",
          },
        ],
      },
    ],
  },
];
